import request from '@/utils/request'

const BASE = '/pm/datacenter'

export const dcApi = {
  // 区域
  regions: () => request.get(`${BASE}/region`),
  createRegion: (data) => request.post(`${BASE}/region`, data),
  updateRegion: (id, data) => request.put(`${BASE}/region/${id}`, data),
  deleteRegion: (id) => request.delete(`${BASE}/region/${id}`),

  // 供方
  suppliers: (params) => request.get(`${BASE}/supplier`, { params }),
  createSupplier: (data) => request.post(`${BASE}/supplier`, data),
  updateSupplier: (id, data) => request.put(`${BASE}/supplier/${id}`, data),
  blacklist: (id, reason) => request.post(`${BASE}/supplier/${id}/blacklist`, null, { params: { reason } }),

  // 对接系统
  integrations: () => request.get(`${BASE}/integration`),
  createIntegration: (data) => request.post(`${BASE}/integration`, data),
  updateIntegration: (id, data) => request.put(`${BASE}/integration/${id}`, data),

  // API 日志
  apiLogs: (params) => request.get(`${BASE}/api-log`, { params }),

  // 数据质量
  qualityIssues: (params) => request.get(`${BASE}/quality-issue`, { params }),
  fixIssue: (id) => request.post(`${BASE}/quality-issue/${id}/fix`),
  qualityScan: () => request.post(`${BASE}/quality/scan`),

  // 集团聚合
  overview: () => request.get(`${BASE}/overview`),
  projectCompare: () => request.get(`${BASE}/project-compare`),
  masterStats: () => request.get(`${BASE}/master-stats`),

  // 项目主数据
  projects: (params) => request.get(`${BASE}/project`, { params }),
  projectDetail: (id) => request.get(`${BASE}/project/${id}`),
  createProject: (data) => request.post(`${BASE}/project`, data),
  updateProject: (id, data) => request.put(`${BASE}/project/${id}`, data),
  deleteProject: (id) => request.delete(`${BASE}/project/${id}`),
  batchConfigProject: (data) => request.post(`${BASE}/project/batch-config`, data),
  copyProjectRules: (id, data) => request.post(`${BASE}/project/${id}/copy-rules`, data),

  // 客户主数据
  customers: (params) => request.get(`${BASE}/customer`, { params }),
  customerDetail: (id) => request.get(`${BASE}/customer/${id}`),
  createCustomer: (data) => request.post(`${BASE}/customer`, data),
  updateCustomer: (id, data) => request.put(`${BASE}/customer/${id}`, data),
  deleteCustomer: (id) => request.delete(`${BASE}/customer/${id}`),
  mergeCustomer: (data) => request.post(`${BASE}/customer/merge`, data),
  customerAudits: (id) => request.get(`${BASE}/customer/${id}/audit`),
  exportCustomers: (params) => request.get(`${BASE}/customer/export`, { params }),

  // 资源主数据
  resources: (params) => request.get(`${BASE}/resource`, { params }),
  resourceMap: (params) => request.get(`${BASE}/resource/map`, { params }),
  resourceHistory: (id) => request.get(`${BASE}/resource/${id}/history`),
  resourceOpsLedger: (params) => request.get(`${BASE}/resource/ops-ledger`, { params }),
  createResource: (data) => request.post(`${BASE}/resource`, data),
  updateResource: (id, data) => request.put(`${BASE}/resource/${id}`, data),
  deleteResource: (id) => request.delete(`${BASE}/resource/${id}`),

  // 集采
  catalogs: (params) => request.get(`${BASE}/procurement/catalog`, { params }),
  createCatalog: (data) => request.post(`${BASE}/procurement/catalog`, data),
  updateCatalog: (id, data) => request.put(`${BASE}/procurement/catalog/${id}`, data),
  orders: (params) => request.get(`${BASE}/procurement/order`, { params }),
  createOrder: (data) => request.post(`${BASE}/procurement/order`, data),
  updateOrderStatus: (id, status) => request.put(`${BASE}/procurement/order/${id}/status`, null, { params: { status } }),

  // 空间
  spaceTree: (projectId) => request.get(`${BASE}/space/tree`, { params: { projectId } }),
  spaces: (params) => request.get(`${BASE}/space`, { params }),
  createSpace: (data) => request.post(`${BASE}/space`, data),
  updateSpace: (id, data) => request.put(`${BASE}/space/${id}`, data),
  deleteSpace: (id) => request.delete(`${BASE}/space/${id}`),
  grids: (projectId) => request.get(`${BASE}/grid`, { params: { projectId } }),
  dispatchGrid: (id, taskType) => request.post(`${BASE}/grid/${id}/dispatch`, null, { params: { taskType: taskType || 'REPAIR' } }),
  createGrid: (data) => request.post(`${BASE}/grid`, data),
  updateGrid: (id, data) => request.put(`${BASE}/grid/${id}`, data),
  deleteGrid: (id) => request.delete(`${BASE}/grid/${id}`),

  // 员工
  employees: (params) => request.get(`${BASE}/employee`, { params }),
  employeeDetail: (id) => request.get(`${BASE}/employee/${id}`),
  createEmployee: (data) => request.post(`${BASE}/employee`, data),
  updateEmployee: (id, data) => request.put(`${BASE}/employee/${id}`, data),
  deleteEmployee: (id) => request.delete(`${BASE}/employee/${id}`),

  // 门禁道闸
  accessLogs: (params) => request.get(`${BASE}/access/log`, { params }),
  createAccessLog: (data) => request.post(`${BASE}/access/log`, data),
  vehiclePasses: (params) => request.get(`${BASE}/vehicle/pass`, { params }),
  createVehiclePass: (data) => request.post(`${BASE}/vehicle/pass`, data),
  plateWhitelist: (projectId) => request.get(`${BASE}/plate-whitelist`, { params: { projectId } }),
  createWhitelist: (data) => request.post(`${BASE}/plate-whitelist`, data),
  deleteWhitelist: (id) => request.delete(`${BASE}/plate-whitelist/${id}`),

  // EBA
  ebaDevices: (params) => request.get(`${BASE}/eba/device`, { params }),
  createEbaDevice: (data) => request.post(`${BASE}/eba/device`, data),
  updateEbaDevice: (id, data) => request.put(`${BASE}/eba/device/${id}`, data),
  controlEba: (id, data) => request.post(`${BASE}/eba/device/${id}/control`, data),
  ebaAlarms: (params) => request.get(`${BASE}/eba/alarm`, { params }),
  createEbaAlarm: (data) => request.post(`${BASE}/eba/alarm`, data),
  closeEbaAlarm: (id) => request.post(`${BASE}/eba/alarm/${id}/close`),

  // 400
  calls: (params) => request.get(`${BASE}/call`, { params }),
  createCall: (data) => request.post(`${BASE}/call`, data),
  linkWorkOrder: (id, workOrderId) => request.put(`${BASE}/call/${id}/link-order`, null, { params: { workOrderId } }),
  uploadCallRecording: (file) => {
    const fd = new FormData()
    fd.append('file', file)
    return request.post(`${BASE}/call/upload`, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  attachCallRecording: (id, recordingUrl) => request.put(`${BASE}/call/${id}/recording`, null, { params: { recordingUrl } }),

  // API 注册
  apiRegistry: (params) => request.get(`${BASE}/api-registry`, { params }),
  createApi: (data) => request.post(`${BASE}/api-registry`, data),
  updateApi: (id, data) => request.put(`${BASE}/api-registry/${id}`, data),
  deleteApi: (id) => request.delete(`${BASE}/api-registry/${id}`),

  // 治理
  shareRules: () => request.get(`${BASE}/share-rule`),
  createShareRule: (data) => request.post(`${BASE}/share-rule`, data),
  updateShareRule: (id, data) => request.put(`${BASE}/share-rule/${id}`, data),
  dicts: () => request.get(`${BASE}/dict`),
  createDict: (data) => request.post(`${BASE}/dict`, data),
  dictItems: (id) => request.get(`${BASE}/dict/${id}/items`),
  createDictItem: (data) => request.post(`${BASE}/dict/item`, data),
  lineages: () => request.get(`${BASE}/lineage`),
  createLineage: (data) => request.post(`${BASE}/lineage`, data),

  // 权限
  roleScopes: () => request.get(`${BASE}/role-scope`),
  myScope: () => request.get(`${BASE}/my-scope`),
  createRoleScope: (data) => request.post(`${BASE}/role-scope`, data),
  updateRoleScope: (id, data) => request.put(`${BASE}/role-scope/${id}`, data),
  deleteRoleScope: (id) => request.delete(`${BASE}/role-scope/${id}`),

  qualityMerge: (id) => request.post(`${BASE}/quality-issue/${id}/merge`),

  // 运营增强（V128 / DcOps）
  orgTree: () => request.get(`${BASE}/org-tree`),
  mergeProjects: (data) => request.post(`${BASE}/project/merge`, data, { headers: { 'X-Confirm-Sensitive': 'true' } }),
  splitProject: (id, data) => request.post(`${BASE}/project/${id}/split`, data, { headers: { 'X-Confirm-Sensitive': 'true' } }),
  projectHistory: (id) => request.get(`${BASE}/project/${id}/history`),
  refreshPortrait: (id) => request.post(`${BASE}/customer/${id}/refresh-portrait`),
  customerProfile: (id) => request.get(`${BASE}/customer/${id}/profile`),
  applyMergeRequest: (data) => request.post(`${BASE}/customer/merge-request`, data),
  pendingMerges: () => request.get(`${BASE}/customer/merge-request`),
  decideMerge: (id, approve) => request.post(`${BASE}/customer/merge-request/${id}/decide`, null, {
    params: { approve },
    headers: { 'X-Confirm-Sensitive': 'true' }
  }),
  redeemPass: (data) => request.post(`${BASE}/access/redeem-pass`, data),
  scanCert: (withinDays) => request.post(`${BASE}/alert/scan-cert`, null, { params: { withinDays: withinDays || 30 } }),
  alerts: (params) => request.get(`${BASE}/alert`, { params }),
  closeAlert: (id) => request.post(`${BASE}/alert/${id}/close`),
  mdmVersions: (params) => request.get(`${BASE}/mdm/version`, { params }),
  mdmEvents: (params) => request.get(`${BASE}/mdm/event`, { params }),
  mdmAutoResolve: () => request.post(`${BASE}/mdm/conflict/auto-resolve`),
  supplierContracts: (id) => request.get(`${BASE}/supplier/${id}/contracts`),
  saveSupplierContract: (id, data) => request.post(`${BASE}/supplier/${id}/contract`, data),
  deleteSupplierContract: (id) => request.delete(`${BASE}/supplier/contract/${id}`),
  invokeApi: (apiCode, data, apiKey) => request.post(`${BASE}/api-invoke/${apiCode}`, data || {}, {
    headers: apiKey ? { 'X-Api-Key': apiKey } : {}
  }),
  receiptAccounts: () => request.get(`${BASE}/receipt-account`),
  refreshSupplierRating: () => request.post(`${BASE}/supplier/refresh-rating`),
  settleSummary: () => request.get(`${BASE}/procurement/settle-summary`),

  mergeCustomerConfirm: (data) => request.post(`${BASE}/customer/merge`, data, { headers: { 'X-Confirm-Sensitive': 'true' } }),
  deleteCustomerConfirm: (id) => request.delete(`${BASE}/customer/${id}`, { headers: { 'X-Confirm-Sensitive': 'true' } }),
  deleteProjectConfirm: (id) => request.delete(`${BASE}/project/${id}`, { headers: { 'X-Confirm-Sensitive': 'true' } })
}

export function downloadCsv(filename, rows, headers) {
  const cols = headers || (rows[0] ? Object.keys(rows[0]) : [])
  const esc = (v) => {
    const s = v == null ? '' : String(v)
    return /[",\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s
  }
  const lines = [cols.join(',')].concat(rows.map(r => cols.map(c => esc(r[c])).join(',')))
  const blob = new Blob(['\ufeff' + lines.join('\n')], { type: 'text/csv;charset=utf-8;' })
  const a = document.createElement('a')
  a.href = URL.createObjectURL(blob)
  a.download = filename
  a.click()
  URL.revokeObjectURL(a.href)
}
